/* eslint-disable no-empty-pattern */
import axios from "@/helpers/axios";
import { dateUTC } from "@/helpers/date";
import _ from "lodash";

export default {
  changeActiveTrail(context, trails) {
    context.commit("changeTrail", trails);
  },

  /**
   * Add New Company
   */
  async addCompany({}, form) {
    await axios.post("/companies", form);
  },

  /**
   * Add Company Member
   */
  async addCompanyMember({}, data) {
    await axios.post("/companies/users", data);
  },

  async addEventMeta({}, form) {
    let addEventMeta = await axios
      .post("/events/" + form[0].eventId + "/meta", form)
      .then(response => {
        return response;
      });

    return addEventMeta;
  },

  /**
   * Add New Member
   */
  async addNewMember({}, data) {
    await axios.post("/users", data);
  },

  async deleteEventMeta({}, eventId) {
    let deleteEventMeta = axios
      .delete("/events/" + eventId + "/meta")
      .then(response => {
        return response;
      });
    return deleteEventMeta;
  },

  async deleteEvent({}, eventId) {
    let deleteEvent = axios.delete("/events/" + eventId).then(response => {
      return response;
    });
    return deleteEvent;
  },

  /**
   * Get all company
   */
  async fetchCompanies(context, links) {
    let url = "companies";
    if (links) {
      url = links.next ? links.next.split("/")[3] : url;
      url = links.officeType
        ? `companies?categoryId=${links.officeType.value}`
        : url;
    }
    let companies = await axios.get(`/${url}`).then(result => {
      return result.status == 200 ? result.data : [];
    });
    Object.keys(companies.data).map(key => {
      companies.data[key].companyType = companies.data[key].Category.name;
      companies.data[key].currentlyBooked = "";
    });
    context.commit("GET_COMPANIES", companies);
  },

  /**
   * Orders
   */
  async fetchOrders(context, options) {
    await context.commit("SET_ORDER_STATUS", "pending");

    let url = options
      ? options.link
        ? options.link.split("/")[3]
        : "orders/getTotalOrdersToday"
      : "orders/getTotalOrdersToday";
    if (options && options.queryParams) {
      url += url.includes("?")
        ? "&" + options.queryParams
        : "?" + options.queryParams;
    }
    let orders = await axios.get(`/${url}`).then(result => {
      return result.status == 200 ? result.data : [];
    });
    await context.commit("GET_ORDERS", orders);
  },

  /**
   * get total sales of orders
   */
  async fetchTotalSales(context, link) {
    let totalSales = await axios.get(`/${link}`).then(result => {
      return result.status == 200 ? result.data : [];
    });
    context.commit("GET_ORDERS_TOTAL_SALES", totalSales);

    return totalSales;
  },

  /**
   * Get list of all users
   */
  async fetchUsers(context, options) {
    let url = options
      ? options.link
        ? options.link.split("/")[3]
        : "users"
      : "users";

    if (options && options.queryParams) {
      url += url.includes("?")
        ? "&" + options.queryParams
        : "?" + options.queryParams;
    }

    let users = await axios.get(`/${url}`).then(result => {
      return result.status == 200 ? result.data : [];
    });

    if (options && options.mode && options.mode == "pagination") {
      context.commit("GET_USERS_FOR_PAGINATION", users);
    } else {
      context.commit("GET_USERS_FOR_INFINTE_SCROLL", users);
    }
  },

  /**
   * Remove Company
   */

  async removeCompany({}, companyId) {
    await axios.delete(`/companies/${companyId}`);
  },
  /**
   * Get All Events
   */
  async fetchEvents(context, links) {
    let url = links ? links.next.split("/")[3] : "events";
    let events = await axios.get(`/${url}`).then(result => {
      return result.status == 200 ? result.data : [];
    });
    context.commit("GET_EVENTS", events);
  },
  /**
   * Get Recent Events for User DashBoard
   */
  async fetchRecentEvents(context, link) {
    let url = link;
    let events = await axios.get(`/${url}`).then(result => {
      return result.status == 200 ? result.data : [];
    });
    context.commit("GET_EVENTS", events);
  },

  /**
   * Add New Event
   */
  async postEvent({}, form) {
    form.startDate = dateUTC(form.startDate + " " + form.startTime);
    form.endDate = dateUTC(form.endDate + " " + form.endTime);
    let addEvent = await axios.post("/events", form).then(response => {
      return response;
    });

    return addEvent;
  },

  /**
   * Update Company Details
   */
  async patchCompany({}, form) {
    await axios.patch(`/companies/${form.id}`, form.form);
  },

  /**
   * Update Member Details
   */
  async patchMember({}, form) {
    await axios.patch(`/users/${form.id}`, form.form);
  },

  /**
   * Update Company Details
   */
  async patchEvent({}, form) {
    let eventId = form.id;
    form = form.form;

    form.startDate = dateUTC(form.startDate + " " + form.startTime);
    form.endDate = dateUTC(form.endDate + " " + form.endTime);
    let editEvent = await axios
      .patch(`/events/${eventId}`, form)
      .then(response => {
        return response;
      });
    return editEvent;
  },

  /**
   * Remove Member
   */
  async removeMember({}, userId) {
    await axios.delete(`/users/${userId}`);
  },

  /**
   * Search Users
   */
  async searchUsers(context, searchTerm) {
    let splitSearchTerm = searchTerm.split(" ");

    let users = await axios
      .get(
        `/users?search[firstName]=${splitSearchTerm[0]}&search[lastName]=${splitSearchTerm[0]}&search[email]=${splitSearchTerm[0]}`
      )
      .then(result => {
        if (result.status != 200) {
          return [];
        } else {
          if (result.data.data == null) {
            let user = { data: [], links: {}, meta: {} };
            return user;
          } else {
            Object.keys(result.data.data).map(val => {
              let rows = result.data.data[val];
              result.data.data[val].fullName =
                rows.firstName + " " + rows.lastName;
            });
            return result.data;
          }
        }
      });
    if (splitSearchTerm.length > 1) {
      users.data = _.filter(users.data, val => {
        return val.fullName.toUpperCase().includes(searchTerm.toUpperCase());
      });
    }
    context.commit("GET_USERS_FOR_INFINTE_SCROLL", users);
  },

  async searchEvent(context, searchTerm) {
    let events = await axios.get(`/events?name=${searchTerm}`).then(result => {
      return result.status == 200 ? result.data : [];
    });
    context.commit("GET_EVENTS", events);
  },

  /**
   * Search Company
   */
  async searchCompany(context, searchTerm) {
    let companies = await axios
      .get(`/companies?name=${searchTerm}`)
      .then(result => {
        return result.status == 200 ? result.data : [];
      });
    Object.keys(companies.data).map(key => {
      companies.data[key].companyType = companies.data[key].Category.name;
      companies.data[key].currentlyBooked = "";
    });
    context.commit("GET_COMPANIES", companies);
  },

  /**
   * Get Options
   */
  async fetchOptions(context, searchItem) {
    let url =
      searchItem != "" && typeof searchItem != "undefined"
        ? `options?fresh=1&key=${searchItem}`
        : `options?fresh=1`;
    let options = await axios.get(`/${url}`).then(result => {
      return result.status == 200 ? result.data : [];
    });
    context.commit("GET_OPTIONS", options);
    return options;
  },

  /**
   * Add new option
   */
  async postOption({}, form) {
    let addOptions = await axios.post("/options", form).then(response => {
      return response;
    });

    return addOptions;
  },

  /**
   * add new email notification
   */
  async postEmailNotification({}, form) {
    let result = await axios
      .post("/emailnotifications", form)
      .then(response => {
        return response;
      });

    return result;
  },

  /**
   * get all email notification
   */
  async fetchEmailNotification(context, links) {
    let url = links ? links.next.split("/")[3] : "emailnotifications";
    let result = await axios.get(`/${url}`).then(result => {
      return result.status == 200 ? result.data : [];
    });
    context.commit("GET_EMAILNOTIF", result);
  },
  /**
   * update email notification
   */
  async patchEmailNotification({}, form) {
    let id = form.id;
    form = form.form;
    return await axios
      .patch(`/emailnotifications/${id}`, form)
      .then(response => {
        return response;
      });
  },
  /**
   * delete email notification
   */
  async deleteEmailNotification({}, notifId) {
    let result = axios
      .delete("/emailnotifications/" + notifId)
      .then(response => {
        return response;
      });
    return result;
  },
  /**
   * add settings color scheme
   */
  async postScheme({}, form) {
    let id = form.userId;
    let addScheme = await axios
      .post(`/users/${id}/scheme`, form)
      .then(response => {
        return response;
      });

    return addScheme;
  },
  /**
   * get settings color scheme
   */
  async fetchScheme(context, searchItem) {
    let url = `users/${searchItem}/scheme`;
    let scheme = await axios.get(`/${url}`).then(result => {
      return result.status == 200 ? result.data : [];
    });
    await Promise.all([
      context.commit("GET_USER_SCHEME", scheme),
      context.dispatch("updateScheme", scheme)
    ]);
    return scheme;
  },

  /**
   * Add New Group
   */
  async addGroup({}, form) {
    await axios.post("/groups", form);
  },

  /**
   * Add Group Member
   */
  async addGroupMember({}, data) {
    await axios.post("/groups/users", data);
  },
  /**
   * Get all group
   */
  async fetchGroups(context, links) {
    let url = "groups";
    if (links) {
      url = links.next ? links.next.split("/")[3] : url;
      url = links.officeType
        ? `groups?categoryId=${links.officeType.value}`
        : url;
    }
    let groups = await axios.get(`/${url}`).then(result => {
      return result.status == 200 ? result.data : [];
    });
    Object.keys(groups.data).map(key => {
      groups.data[key].groupType = groups.data[key].Category.name;
      groups.data[key].currentlyBooked = "";
    });
    context.commit("GET_GROUPS", groups);
  },

  /**
   * Remove Group
   */

  async removeGroup({}, groupId) {
    await axios.delete(`/groups/${groupId}`);
  },

  /**
   * Update Group Details
   */
  async patchGroup({}, form) {
    await axios.patch(`/groups/${form.id}`, form.form);
  },

  /**
   * Search Group
   */
  async searchGroup(context, searchTerm) {
    let groups = await axios.get(`/groups?name=${searchTerm}`).then(result => {
      return result.status == 200 ? result.data : [];
    });
    Object.keys(groups.data).map(key => {
      groups.data[key].groupType = groups.data[key].Category.name;
      groups.data[key].currentlyBooked = "";
    });
    context.commit("GET_GROUPS", groups);
  },

  SET_REPORT_FILTER(context, data) {
    context.commit("SET_REPORT_FILTER", data);
  },

  SET_REPORT_HISTORY(context, data) {
    context.commit("SET_REPORT_HISTORY", data);
  },

  SET_STRIPE_CHECKOUT(context, data) {
    context.commit("SET_STRIPE_CHECKOUT", data);
  }
};
